import { render, staticRenderFns } from "./ChangePasswordSalon.vue?vue&type=template&id=a0188890"
import script from "./ChangePasswordSalon.vue?vue&type=script&lang=js"
export * from "./ChangePasswordSalon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports